
import { gameNavOptions } from "../../../libs/options.js";
import { mapState, mapMutations } from "vuex";
import { common, commonApi } from "@/common/index";
import Search from "../search/index.vue";
import loadMoreBtn from "@/common/components/load-more-btn/index.vue";
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'

import loadMore from "@/common/components/load-more/index.vue";
import listItem from "./list-item.vue";

export default {
name: "gamelist",
components: {
Search,
loadMoreBtn,
loadMore,
listItem,
Confirm,
},
directives: {
TransferDom,
},
data() {
return {
loading: true,
gameNavOptions: gameNavOptions,
showPhone: false,
gameSwiperIndex: 0,
loadmore: true,
platformCode: null,
platform: null, // 平台的相关信息 比如维护信息
gameType: null,
curGameConfig: {},
gamePlatformList: [], // 平台列表
PicInfoList: [], // 平台图片列表
gameList: [],
listData: {}, // 储存第一次的数据
gameListTop: [], //游戏列表的高度集合
menuIndexChange: true,
};
},
computed: {
...mapState({
isLogin: (state) => state.isLogin,
UUID: (state) => state.UUID,
frontType: (state) => state.frontType,
upholdShow: (state) => state.upholdShow,
staticDomain: (state) => state.linkList.staticDomain,
}),
},
created() {},
mounted() {
this.normalGame();
},
watch: {},
methods: {
...mapMutations(["SET_LOGIN_SHOW", "SET_JIN_GAMEITEM", "setupholdShow"]),
getTabIndex(v) {

return this.gameNavOptions.findIndex((item) =>
v.gameId === "3"
? item.gameId === v.gameId && item.isESports === v.isESports
: item.gameId === v.gameId
);
},
_updateGameList(v) {
this.gameSwiperIndex = this.getTabIndex(v);
},
handleChangeGame(index) {
this.curGameConfig = this.gameNavOptions[index];
},

normalGame() {


this.$store.commit("updateLoadingStatus", { isLoading: true });
commonApi.HOMEBEFORE.gamePlatform({
frontType: this.frontType,
})
.then((data) => {
let list = data.list || [];
if (list.length > 0) {
this.gameNavOptions.forEach((navOption, index) => {

const gameList = [];


list
.filter((item) => item.platformKey !== "Poker_CHESS")
.forEach((listItem) => {

if (navOption.gameId === listItem.gameType) {

if (
(navOption.isESports === "1" &&
listItem.isESports === "1") ||
(navOption.isESports !== "1" &&
listItem.isESports !== "1")
) {
gameList.push(listItem);
}
}
});

this.$set(this.gameNavOptions[index], "list", gameList);
});

this.gameNavOptions = this.gameNavOptions.filter(
(item) => item.list.length > 0
);

this.curGameConfig = this.gameNavOptions[0];
this.loading = false;
this.this.$store.commit("updateLoadingStatus", {
isLoading: false,
});
}
})
.catch((err) => {
this.$store.commit("updateLoadingStatus", { isLoading: false });
});
},
passConfirm() {
this.$router.push("/My/AccountManat/mobileAuth");
},
passCancel() {
this.showPhone = false;
},
goGame(item) {

const { gameType, platformCode, platformKey } = item;

if (gameType === "1" || gameType === "5") {
this.$router.push({
path: `/game/${gameType}`,
query: {
platformCode,
platformKey,
},
});
} else {
let maintain = item.maintain;
if (maintain === "0") {

if (this.isLogin) {
if (item.platformKey === "Poker_CHESS") {
return this.$router.push("/");
}
if (
this.$store.state.linkList.gameCertifiedMobilePhone == "1" &&
!this.$store.state.userInfo.userInfo.mobileValid
) {
this.showPhone = true;
} else {
common.goGame(item, this.isLogin, this.UUID, this.$router); 
}
} else {
this.SET_LOGIN_SHOW();
}
} else {
let maintainRemarks = item.maintainRemarks;
this.$store.commit("setupholdInfo", maintainRemarks);
this.setupholdShow(true); 
}
}
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/components/game/list.vue